export default __webpack_public_path__ + "static/media/APPMOVIL.eb1ece12.gif";